import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { Incoterm, IncotermFilters } from '../../../../app/models/Incoterm';
import IncotermSwitchChange from '../IncotermSwitchChange';

interface Props {
    incoterms: Incoterm[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    active?: (id: number, active: boolean) => void;
    destroy?: (id: number) => void;
    filter: IncotermFilters;
    setFilter: (filter: IncotermFilters) => void;
    callbackSuccess: () => void;
}

const IncotermDataTable = ({
    incoterms,
    totalRows,
    loading = false,
    edit,
    destroy,
    active,
    filter,
    setFilter,
    callbackSuccess
}: Props) => {
    const columns = [
        {
            name: 'ID',
            selector: (row: any) => row.id,
            sortable: true,
            sortField: 'id',
            width: '80px',
            cell: (row: Incoterm) => <span>{row.id}</span>
        },
        {
            name: 'Nombre',
            selector: (row: any) => row.name,
            sortable: true,
            sortField: 'name',
            cell: (row: Incoterm) => <span>{row.name}</span>
        },
        {
            name: 'Descripción',
            selector: (row: any) => row.description,
            sortable: false,
            cell: (row: Incoterm) => <span>{row.description || '-'}</span>
        },
        {
            name: 'Activo',
            selector: (row: any) => row.is_active,
            sortable: true,
            sortField: 'is_active',
            width: '100px',
            cell: (row: Incoterm) => (
                <IncotermSwitchChange
                    checkValue={row.is_active ?? true}
                    incotermId={row.id!}
                    callbackSuccess={callbackSuccess}
                />
            )
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            width: '150px',
            cell: (row: Incoterm) => (
                <div className="">
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    {/* Filtros pueden agregarse aquí si es necesario */}
                </div>
            </div>

            <DefaultDataTable
                columns={columns}
                data={incoterms}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default IncotermDataTable;
